import React from "react";
import { MuiThemeProvider } from "@material-ui/core/styles";
import { Typography, Grid } from "@material-ui/core";
import { Link } from 'react-router-dom'
import { theme } from "./theme";
import coming from "../assets/coming.png";
// import "./temp.css";
import {Helmet} from "react-helmet";

const Error = ({ type,history }) => {
  return (
    <MuiThemeProvider theme={theme}>
       <Helmet>
          <title>Error!! No Such Page</title>
        </Helmet>

      <Grid container className="fadeInUp" style={{ animationDelay: "0.72s" }}>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{ alignSelf: "center" }}
          id="image-grid"
        >
          <div className="error fadeInUp" style={{ animationDelay: "0.58s" }}>
            <img src={coming} alt='coming' className="error-image" />
          </div>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={6}
          style={{ alignSelf: "center",margin: '0 auto' }}
          id="image-grid"
        >
          <Typography
            variant="h3"
            className="head-description fadeInUp"
            style={{ animationDelay: "0.58s", margin: "0 auto" }}
          >
            UH-OH!! Wrong Page
          </Typography>
          <br/>
          <Typography
            variant="h4"
            className="head-description fadeInUp"
            style={{ animationDelay: "0.58s", margin: "0 auto" }}
          >
            <span style={{textDecoration:'underline'}}><Link id="hover" to='/'>Explore our Website</Link></span>
          </Typography>
        </Grid>
      </Grid>
    </MuiThemeProvider>
  );
};

export default Error;
